import MaterialPageTable from "./material-page-table"

export default MaterialPageTable
